import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import PageHeaderErrors from '~/glm/components/shared/layout/page-header-errors';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import styles from './page-header.scss';

class PageHeaderIA extends Component {
  render() {
    const { heading, subHeading, children, event, search, firstTimeCard, showZeroState } = this.props;
    return (
      <Fragment>
        <div className={firstTimeCard ? styles.contentHeaderIACard : styles.contentHeaderIA}>
          <div className={search ? styles.pageHeaderWithSearch : styles.pageHeaderIA}>
            <div>
              {heading}
              {subHeading}
            </div>
            {children}
          </div>
        </div>
        {event && !showZeroState && <PageHeaderErrors event={event} />}
      </Fragment>
    );
  }
}

PageHeaderIA.propTypes = {
  heading: PropTypes.node,
  subHeading: PropTypes.node,
  children: PropTypes.node,
  event: PropTypes.instanceOf(GdsEventModel),
  search: PropTypes.bool,
  firstTimeCard: PropTypes.bool,
  showZeroState: PropTypes.bool,
};

PageHeaderIA.defaultProps = {
  heading: null,
  subHeading: null,
  children: null,
  event: null,
  search: false,
  firstTimeCard: false,
  showZeroState: false,
};

export default PageHeaderIA;
